export const ASSIGNMENT_PERSISTENCE_INTENT = {
    AUTOSAVE: 'autosave',
    PUBLISH: 'publish',
    UNPUBLISH: 'unpublish',
};

export const resolveAssignmentDraftState = ({ intent, persistedAssignment }) => {
    if (intent === ASSIGNMENT_PERSISTENCE_INTENT.PUBLISH) return false;
    if (intent === ASSIGNMENT_PERSISTENCE_INTENT.UNPUBLISH) return true;
    if (persistedAssignment?.id) return Boolean(persistedAssignment.is_draft);
    return true;
};
